<template lang="pug">
v-app
  v-app-bar.re-app-bar(app :height="$vuetify.breakpoint.mdAndUp ? 70 : 60")
    v-container.d-flex.align-center
      v-btn(icon @click="$router.back()")
        v-icon mdi-arrow-left
      v-toolbar-title {{ $t("единый_qr") }}
    v-progress-linear(:active="loading" :indeterminate="loading" fixed top color="secondary")

  v-main(flat)
    v-container.pt-0(style="max-width: 450px")
      v-row
        v-col.pt-5(align="center")
          v-img.rounded-xl(src="/static/halyk-qr-banner.png" width="90%" eager)

      v-row
        v-col
          .subtitle-1.text-center.mb-4 {{ $t("принимайте_оплату_от_пользователей_любых_банков_по_единому_qr") }}
          .subtitle-1.text-center.mb-4 {{ $t("единый_qr_работает_через_halyk_qr") }}
          .subtitle-1.text-center.mb-4 {{ $t("комиссия_действует_для_оплаты_от_клиентов_halyk") }}

      v-row
        v-col
          v-btn.text-h5(v-if="!halykQRConnected" color="primary" block :disabled="loading" :loading="loading" @click="onConnect()") {{ $t("подключить") }}
          v-btn.text-h5(v-else color="error" block :disabled="loading" @click="onDisconnect()") {{ $t("отключить") }}
          v-btn.text-subtitle-1.mt-3(color="primary" block text @click="openInstruction()") {{ $t("посмотреть_инструкцию") }}

  v-dialog(v-model="terminalsDialog" max-width="450px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card.px-2
      v-card-title.pb-0.pt-10
        .text-h3 {{ $t("выберите_терминал") }}
        v-spacer
        v-btn.ml-1(icon @click="terminalsDialog = false" :disabled="loading")
          v-icon mdi-close
      v-card-text
        v-container.px-0
          v-form(ref="terminalForm")
            v-radio-group.re-radio-group(v-model="terminalSelect")
              v-radio.mb-6(v-for="(item, $index) in terminalList" :key="'terminal_' + $index" :label="`${item.city}, ${item.address}`" :value="item")
          v-btn(color="secondary" block :disabled="terminalSelect === null" @click="showConnectPinpad()") {{ $t("подключить") }}

  re-pinpad(v-model="connectDialog" :title="$t('подключение_name', { name: $t('единый_qr') })" :subtitle="$t('введите_пин-код')" :text="$t('для_подключения_name', { name: $t('единый_qr') })" :loading="loading" :errorText.sync="connectErrorMessage" @action="connect")
  re-pinpad(v-model="disconnectDialog" :title="$t('отключение_name', { name: $t('единый_qr') })" :subtitle="$t('введите_пин-код')" :text="$t('для_отключения_name', { name: $t('единый_qr') })" :loading="loading" :errorText.sync="disconnectErrorMessage" @action="disconnect")

</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLocale } from '../../i18n'
import Pinpad from '../utils/PinpadDialog.vue'

const INSTRUCTION_URL = `https://link.rekassa.kz/halyk-qr-${getLocale()}`
// Deep link в Onlinebank на подключение Halyk QR - если терминалов по БИН ещё нет
const ONLINEBANK_QR_CONNECT_URL = 'https://link.onlinebank.kz/appLink/qr-connect'

export default {
  components: {
    're-pinpad': Pinpad,
  },

  data: () => ({
    loading: false,

    terminalsDialog: false,
    terminalList: [],
    terminalSelect: null,

    connectDialog: false,
    connectErrorMessage: null,
    disconnectDialog: false,
    disconnectErrorMessage: null,
  }),

  computed: {
    ...mapState({
      user: state => state.auth.user,
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      organization: state => state.cashRegisters.cashRegister.organization,
      configuration: state => state.cashRegisters.cashRegister.cashRegister.data.configuration,
      roles: state => state.cashRegisters.cashRegister.roles,
    }),

    locale() {
      return getLocale()
    },

    isOwner() {
      return (this.roles || []).find(r => r === 'OWNER') !== undefined
    },

    halykQRConnected() {
      return !!(this.configuration && this.configuration.halykQR && this.configuration.halykQR.connected)
    },
  },

  async created() {
    // HALYK_QR_ROLLOUT_GATE: страница достижима по прямой ссылке - уводим,
    // если терминал не подключён и БИН организации не в списке HALYK_QR_CONFIG
    await this.$store.dispatch('halykQr/fetchFeatureConfig')
    if (!this.halykQRConnected && !this.$store.getters['halykQr/featureEnabled']) {
      this.$router.replace('/kkm')
      return
    }
    this.analyticsLogEvent({ eventName: 're_halyk_qr_page_opened' })
  },

  methods: {
    ...mapActions({
      listTerminals: 'halykQr/listTerminals',
      connectTerminal: 'halykQr/connectTerminal',
      disconnectTerminal: 'halykQr/disconnectTerminal',
      checkPassword: 'cashRegisters/checkPassword',
      saveConfiguration: 'cashRegisters/saveConfiguration',
      selectCashRegister: 'cashRegisters/selectCashRegister',
      showSnackbar: 'tools/showSnackbar',
      showConfirm: 'confirm/showConfirm',
      analyticsLogEvent: 'analytics/logEvent',
    }),

    openInstruction() {
      this.analyticsLogEvent({ eventName: 're_halyk_qr_instruction_clicked' })
      this.$openLink(INSTRUCTION_URL, '_system')
    },

    isShiftClosed() {
      if (this.cashRegister.shiftOpen) {
        this.showConfirm({
          title: this.$t('требуется_закрыть_смену_чтобы_поменять_данный_параметр'),
          resolveText: this.$t('закрыть_смену'),
          rejectText: this.$t('отменить'),
        }).then(() => {
          this.$router.push(`/shifts/${this.cashRegister.id}/${this.cashRegister.shiftNumber}/zxreport`)
        }).catch(() => {})
        return false
      }
      return true
    },

    // Подключать может только владелец зарегистрированной кассы
    checkConnectAllowed() {
      if (this.cashRegister.status !== 'REGISTERED') {
        this.analyticsLogEvent({ eventName: 're_halyk_qr_connect_denied', eventProperties: { reason: 'NOT_REGISTERED' } })
        this.showConfirm({
          icon: 'mdi-alert-circle-outline',
          title: this.$t('касса_не_зарегистрирована'),
          text: this.$t('подключить_единый_qr_можно_только_на_зарегистрированной_кассе'),
          resolveText: this.$t('понятно'),
        }).catch(() => {})
        return false
      }

      if (!this.isOwner) {
        this.analyticsLogEvent({ eventName: 're_halyk_qr_connect_denied', eventProperties: { reason: 'NOT_OWNER' } })
        this.showConfirm({
          icon: 'mdi-account-lock-outline',
          title: this.$t('нет_доступа_на_подключение'),
          text: this.$t('подключить_единый_qr_может_только_владелец'),
          resolveText: this.$t('понятно'),
        }).catch(() => {})
        return false
      }

      return true
    },

    // Онбординг Halyk для организаций без договора ОБР - с возвратом на эту страницу
    onboardingUrl() {
      return `https://onboard.${this.$isTestMode() ? 'test.' : ''}onlinebank.kz/entry?client_id=rekassa_ip&phone_number=${this.user.phone.replace('+7', '')}&lang=${getLocale() === 'kk' ? 'kaz' : 'rus'}&redirect_url=${import.meta.env.VITE_API_ROOT_URL}/kkm/halyk/qr`
    },

    onConnect() {
      this.analyticsLogEvent({ eventName: 're_halyk_qr_connect_started' })

      if (!this.checkConnectAllowed() || !this.isShiftClosed()) {
        return
      }

      this.loading = true
      this.terminalSelect = null
      this.terminalList = []
      this.listTerminals({ bin: this.organization.businessId }).then((result) => {
        this.loading = false
        const terminals = (result.data && result.data.terminals) || []

        // Терминала ещё нет: obr = у организации уже есть договор ОБР - ведём сразу
        // подключать QR в Onlinebank; иначе - на онбординг (открытие счёта).
        // Нет поля (старый бэк) - ведём как при obr: true
        if (terminals.length === 0) {
          const obr = !result.data || result.data.obr !== false
          const url = obr ? ONLINEBANK_QR_CONNECT_URL : this.onboardingUrl()
          this.analyticsLogEvent({ eventName: 're_halyk_qr_onlinebank_opened', eventProperties: { target: obr ? 'QR_CONNECT' : 'ONBOARDING' } })
          // Мы вне стека жеста (после ответа сервера) - мобильный Safari блокирует
          // window.open и возвращает null; тогда уходим по ссылке в текущей вкладке
          const opened = this.$openLink(url, '_system')
          if (!opened) {
            window.location.assign(url)
          }
          return
        }

        // Обычно терминал один - подключаем его без лишнего выбора
        if (terminals.length === 1) {
          [this.terminalSelect] = terminals
          this.connectDialog = true
          return
        }

        this.terminalList = terminals
        this.terminalsDialog = true
      }).catch((error) => {
        this.loading = false
        this.showSnackbar({ message: this.getErrorMessage(error) })
      })
    },

    onDisconnect() {
      this.analyticsLogEvent({ eventName: 're_halyk_qr_disconnect_started' })
      if (this.isShiftClosed()) {
        this.disconnectDialog = true
      }
    },

    showConnectPinpad() {
      this.terminalsDialog = false
      this.connectDialog = true
    },

    getModifiedConfiguration(modifiedConfiguration) {
      return {
        ...this.configuration,
        halykQR: modifiedConfiguration,
      }
    },

    getErrorMessage(error) {
      const code = error && error.response && error.response.data && error.response.data.error && error.response.data.error.code
      return code && this.$te(`halykQr/${code}`) ? this.$t(`halykQr/${code}`) : this.$t('произошла_ошибка')
    },

    async connect(pincode) {
      this.loading = true
      try {
        const form = new FormData()
        form.append('password', pincode)

        const { data: check } = await this.checkPassword({ cashRegister: this.cashRegister, data: form })
        if (!check.result) {
          this.connectErrorMessage = this.$t('backend/WRONG_PASSWORD')
          return
        }

        const { data: connectResult } = await this.connectTerminal({
          cashRegisterId: this.cashRegister.id,
          terminalId: this.terminalSelect.terminalId,
          bin: this.organization.businessId,
        })

        await this.saveConfiguration({
          cashRegister: this.cashRegister,
          configuration: this.getModifiedConfiguration({ connected: true, connectDate: connectResult.connectedAt }),
          password: pincode,
        })

        await this.selectCashRegister(this.cashRegister.id)

        this.connectDialog = false
        this.analyticsLogEvent({ eventName: 're_halyk_qr_connected', eventProperties: { date: this.$moment().format('DD-MM-YYYY') } })

        this.$router.push('/kkm')
        this.showConfirm({
          icon: 'mdi-check',
          title: this.$t('единый_qr_успешно_подключен'),
          text: this.$t('вы_можете_принимать_оплату'),
          resolveText: this.$t('понятно'),
        }).catch(() => {})
      } catch (error) {
        this.connectDialog = false
        this.showSnackbar({ message: this.getErrorMessage(error) })
      } finally {
        this.loading = false
      }
    },

    async disconnect(pincode) {
      this.loading = true
      try {
        const form = new FormData()
        form.append('password', pincode)

        const { data: check } = await this.checkPassword({ cashRegister: this.cashRegister, data: form })
        if (!check.result) {
          this.disconnectErrorMessage = this.$t('backend/WRONG_PASSWORD')
          return
        }

        const { data: disconnectResult } = await this.disconnectTerminal({ cashRegisterId: this.cashRegister.id })

        await this.saveConfiguration({
          cashRegister: this.cashRegister,
          configuration: this.getModifiedConfiguration({ connected: false, disconnectDate: disconnectResult.disconnectedAt }),
          password: pincode,
        })

        await this.selectCashRegister(this.cashRegister.id)

        this.disconnectDialog = false
        this.showSnackbar({ message: this.$t('успешно_отключен_name', { name: this.$t('единый_qr') }) })
        this.analyticsLogEvent({ eventName: 're_halyk_qr_disconnected', eventProperties: { date: this.$moment().format('DD-MM-YYYY') } })
      } catch (error) {
        this.disconnectDialog = false
        this.showSnackbar({ message: this.getErrorMessage(error) })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.theme--dark.v-card > .v-card__text,
.theme--light.v-card > .v-card__text
  color inherit !important
</style>
